import { Location, LocationDescriptorObject } from 'history';

export function getLocation<T = any>(): Location<T> {
  const state = window.history.state || {};
  const location = {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: state.usr || null,
    key: state.key || 'default',
  };
  return location;
}

export const createPath = (p: LocationDescriptorObject<any>) => {
  const pathname = p.pathname || '/';
  const search = p.search || '';
  const hash = p.hash || '';
  return pathname + search + hash;
};

export const createHref = (
  to: string | LocationDescriptorObject<any>,
): string => {
  return typeof to === 'string' ? to : createPath(to);
};

export const convertObjectToQueryString = (query: any, encode: boolean) => {
  if (!query) {
    return '';
  }
  let queryString = Object.keys(query)
    .map(
      (key) =>
        key + '=' + (encode ? encodeURIComponent(query[key]) : query[key]),
    )
    .join('&');
  if (queryString) {
    queryString = '?' + queryString;
  }
  return queryString;
};

export const convertQueryStringToObject = (
  queryString: string,
  decode: boolean,
): any => {
  if (!queryString) {
    return {};
  }
  const qs = queryString
    .replace(/^\?/, '')
    .split('&')
    .map((item) => {
      const keyValue = item.split('=');
      return {
        name: keyValue[0],
        value: decode ? decodeURIComponent(keyValue[1]) : keyValue[1],
      };
    });
  return qs.reduce((acc, item) => {
    return {
      ...acc,
      [item.name]: item.value,
    };
  }, {});
};
